<template>
  <div class="flex-jc-bt font12 tct-order-panel text-left">
    <div class="item" style="width: 300px">
      <p v-required class="italic-bold title">Delivery Port</p>
      <SpSelect v-model="cargoOrders.delyTag" class="PortsPbd-select" strategy="fixed" checked-icon="triangle"
                width="150" height="20" :show-clear="false" :need-search="false"
                :text-style="{fontSize: '12px', textAlign: 'left', padding: 0, textIndent: 0}"
                placeholder="" type="bottomBorderNone">
        <SpSelectOption v-for="pbo in safePorts" :key="pbo.value" font-size="12px" :label="pbo.label"
                        :value="pbo.value" />
      </SpSelect>
      <div class="mg-t-10">
        <div class="flex-al-center flex-jc-bt mg-b-8">
          <SpSelect v-model="cargoOrders.delyPorts.ports"
                    strategy="fixed"
                    business-type="port" :port-but-single="true"
                    multi-select :text-style="{fontSize: '12px', textAlign: 'left', textIndent: 0, paddingLeft: '12px'}"
                    :multi-but-one-close="true"
                    :custom-selection-disable="true" :custom-selection-disable-length="2"
                    type="warn" height="38" class="flex-1 font-12-select"
                    :placeholder="$l('Port Intention')"
                    :back-option="true" :back-selected-option="true"
                    :options="portOptions" :disabled="cargoOrders.delyPorts.regions?.length > 0||cargoOrders.delyPorts.zones?.length > 0"
                    @change="(value,labels, optionSeleted)=> portChange('delyPort', value, labels, optionSeleted)"
                    @search="(key)=>searchPort('ports',key)" />
          <div class="text-center" style="width: 35px">Or</div>
          <SpSelect v-model="cargoOrders.delyPorts.alternates" class="flex-1 font-12-select"
                    business-type="port" strategy="fixed"
                    multi-select :text-style="{fontSize: '12px', textAlign: 'left', textIndent: 0, paddingLeft: '12px'}"
                    :multi-but-one-close="true"
                    type="warn3" height="38"
                    :placeholder="$l('Port Alternate')"
                    :back-option="true" :back-selected-option="true"
                    :options="portOptions"
                    @search="(key)=>searchPort('ports',key)" />
        </div>
        <SpSelect v-model="cargoOrders.delyPorts.regions"
                  class="font-12-select mg-b-8"
                  business-type="port" strategy="fixed"
                  multi-select :text-style="{fontSize: '12px', textAlign: 'left', textIndent: 0, paddingLeft: '12px'}"
                  :multi-but-one-close="true"
                  :disabled="cargoOrders.delyPorts.ports?.length > 0||cargoOrders.delyPorts.zones?.length > 0"
                  type="warn" :options="countryOptions" height="38"
                  :placeholder="$l('Country or SAR')"
                  :back-option="true" :back-selected-option="true"
                  @change="(value,labels, optionSeleted)=> setdelyPortsSelected('delyPortRegionLabels', labels, optionSeleted)"
                  @search="(key)=>searchPort('regions',key)" />
        <SpSelect v-model="cargoOrders.delyPorts.zones"
                  class="font-12-select mg-b-8"
                  business-type="port" strategy="fixed"
                  multi-select :text-style="{fontSize: '12px', textAlign: 'left', textIndent: 0, paddingLeft: '12px'}"
                  :multi-but-one-close="true"
                  :disabled="cargoOrders.delyPorts.ports?.length > 0||cargoOrders.delyPorts.regions?.length > 0"
                  type="warn" :options="zoneOptions" height="48"
                  :placeholder="$l('Sea Area')"
                  :back-option="true" :back-selected-option="true"
                  @change="(value,labels, optionSeleted)=>setdelyPortsSelected('delyPortZoneLabels', labels, optionSeleted)"
                  @search="(key)=>searchPort('zones',key)" />
        <div class="font12 fs-int zone-title">{{ $l('Involved Country & SAR ') }}</div>
        <div class="labels-panel">
          {{ delyPortsSelected?.port || delyPortsSelected?.region || delyPortsSelected?.zone }}
        </div>
      </div>
    </div>
    <div class="item" style="width: 300px">
      <p v-required class="italic-bold title">Redelivery Port</p>
      <SpSelect v-model="cargoOrders.redelTag" class="PortsPbd-select" strategy="fixed" checked-icon="triangle"
                width="150" height="20" :show-clear="false" :need-search="false"
                :text-style="{fontSize: '12px', textAlign: 'left', padding: 0, textIndent: 0}"
                placeholder="" type="bottomBorderNone">
        <SpSelectOption v-for="pbo in safePorts" :key="pbo.value" font-size="12px" :label="pbo.label"
                        :value="pbo.value" />
      </SpSelect>
      <div class="mg-t-10">
        <div class="flex-al-center flex-jc-bt mg-b-8">
          <SpSelect v-model="cargoOrders.redelPorts.ports"
                    strategy="fixed"
                    business-type="port" :port-but-single="true"
                    multi-select :text-style="{fontSize: '12px', textAlign: 'left', textIndent: 0, paddingLeft: '12px'}"
                    :multi-but-one-close="true"
                    :custom-selection-disable="true" :custom-selection-disable-length="2"
                    type="warn" height="38" class="flex-1 font-12-select"
                    :placeholder="$l('Port Intention')"
                    :back-option="true" :back-selected-option="true"
                    :options="portOptions" :disabled="cargoOrders.redelPorts.regions?.length > 0||cargoOrders.redelPorts.zones?.length > 0"
                    @change="(value,labels, optionSeleted)=> portChange('redelPort', value, labels, optionSeleted)"
                    @search="(key)=>searchPort('ports',key)" />
          <div class="text-center" style="width: 35px">Or</div>
          <SpSelect v-model="cargoOrders.redelPorts.alternates" class="flex-1 font-12-select"
                    business-type="port" strategy="fixed"
                    multi-select :text-style="{fontSize: '12px', textAlign: 'left', textIndent: 0, paddingLeft: '12px'}"
                    :multi-but-one-close="true"
                    type="warn3" height="38"
                    :placeholder="$l('Port Alternate')"
                    :back-option="true" :back-selected-option="true"
                    :options="portOptions" :disabled="cargoOrders.redelPorts.regions?.length > 0||cargoOrders.redelPorts.zones?.length > 0"
                    @search="(key)=>searchPort('ports',key)" />
        </div>
        <SpSelect v-model="cargoOrders.redelPorts.regions"
                  class="font-12-select mg-b-8"
                  business-type="port" strategy="fixed"
                  multi-select :text-style="{fontSize: '12px', textAlign: 'left', textIndent: 0, paddingLeft: '12px'}"
                  :multi-but-one-close="true"
                  :disabled="cargoOrders.redelPorts.ports?.length > 0||cargoOrders.redelPorts.zones?.length > 0"
                  type="warn" :options="countryOptions" height="38"
                  :placeholder="$l('Country or SAR')"
                  :back-option="true" :back-selected-option="true"
                  @change="(value,labels, optionSeleted)=> setredelPortsSelected('redelPortRegionLabels', labels, optionSeleted)"
                  @search="(key)=>searchPort('regions',key)" />
        <SpSelect v-model="cargoOrders.redelPorts.zones"
                  class="font-12-select mg-b-8"
                  business-type="port" strategy="fixed"
                  multi-select :text-style="{fontSize: '12px', textAlign: 'left', textIndent: 0, paddingLeft: '12px'}"
                  :multi-but-one-close="true"
                  :disabled="cargoOrders.redelPorts.ports?.length > 0||cargoOrders.redelPorts.regions?.length > 0"
                  type="warn" :options="zoneOptions" height="48"
                  :placeholder="$l('Sea Area')"
                  :back-option="true" :back-selected-option="true"
                  @change="(value,labels, optionSeleted)=>setredelPortsSelected('redelPortZoneLabels', labels, optionSeleted)"
                  @search="(key)=>searchPort('zones',key)" />
        <div class="font12 fs-int zone-title">{{ $l('Involved Country & SAR ') }}</div>
        <div class="labels-panel">
          {{ redelPortsSelected?.port || redelPortsSelected?.region || redelPortsSelected?.zone }}
        </div>
      </div>
    </div>
    <div style="width: 324px; padding-top: 12px">
      <div class="font10 pd-t-20" style="background: #FBFBFB">
        <div class="flex-al-center flex-jc-start mg-b-20">
          <div class="text-right" style="width: 97px; padding-right: 6px">
            <span v-required class="font-bold sp-color-18 font12">DWT Required:</span>
          </div>
          <div class="flex-1">
            <DwtSelect v-model="cargoOrders" :default-type="defaultTypes?.dwt" />
          </div>
        </div>
        <div class="geli-bar" />
        <div class="flex-al-center flex-jc-start mg-b-8 pd-t-8">
          <div class="text-right" style="width: 82px; padding-right: 6px">
            <span class="sp-color-18 font12">Duration:</span>
          </div>
          <div class="flex-1">
            <DurationSelect v-model="cargoOrders" :default-type="defaultTypes?.duration" />
          </div>
        </div>
        <div class="flex-al-center flex-jc-start mg-b-8">
          <div class="text-right" style="width: 82px; padding-right: 6px">
            <span class="sp-color-18">With:</span>
          </div>
          <div class="flex-1">
            <div class="flex-al-center flex-jc-start">
              <SpInput v-model="cargoOrders.llMin"
                       :height="16" :width="40" type="bottomBorder2" class=""
                       :precision="1" text-type="number" :min="1" :max="5"
                       :text-style="{fontSize: '10px', textAlign: 'center', paddingRight: '4px'}" />
              <span class="zhijian" />
              <SpInput v-model="cargoOrders.llMax"
                       :height="16" :width="40" type="bottomBorder2" class=""
                       :precision="1" text-type="number" :min="1" :max="5"
                       :text-style="{fontSize: '10px', textAlign: 'center', paddingRight: '4px'}" />
              &nbsp;<span class="sp-color-22">LL(Laden Legs)</span>
            </div>
          </div>
        </div>
        <div class="geli-bar" />
        <div class="flex-al-start flex-jc-start mg-b-8 pd-t-8">
          <div class="text-right" style="width: 82px; padding-right: 6px; padding-top: 3px">
            <span class="sp-color-18">Hire Rate:</span>
          </div>
          <div class="flex-1">
            <HireRate ref="HireRateRef" v-model="cargoOrders" :default-type="defaultTypes?.hireRate" />
          </div>
        </div>

        <div style="min-height: 74px">
          <div class="flex-al-center flex-jc-start mg-b-8">
            <div class="text-right" style="width: 82px; padding-right: 6px">
              <span class="sp-color-18">Plus BB:</span>
            </div>
            <div class="flex-1">
              <SpInput v-model="cargoOrders.plusBbLumpsum" :height="16" :width="75" type="bottomBorder2" class=""
                       :text-style="{fontSize: '10px', textAlign: 'center', paddingRight: '8px'}"
                       :precision="0" text-type="number" :min="0" :max="9999999">
                <template #suffixLeft>
                  <span class="sp-color-22" style="width: 40px; display: inline-block">USD</span>
                </template>
              </SpInput>
              <span class="sp-color-22">In Lumpsum</span>
            </div>
          </div>
          <div class="flex-al-center flex-jc-start mg-b-8">
            <div class="text-right" style="width: 82px; padding-right: 6px">
              <span class="sp-color-18">PS:</span>
            </div>
            <div class="flex-1 ps-content">
              <span class="title" style="padding-left: 13px">Actually I want to be</span>
              <div class="flex-al-center flex-jc-start">
                <span style="line-height: 17px"> = &nbsp;</span>
                <div class="flex-1">
                  <div v-show="hireRateDiotType === 'dio'" class="flex-al-center flex-jc-start" style="">
                    <div class="" style="width: auto">
                      <div class="flex-al-center flex-jc-start">
                        <div style="">
                          <div class="flex-jc-end">
                            <SpSelect v-model="cargoOrders.hireRateCc" :height="14" class="font-10-select" :width="36"
                                      type="bottomBorder1" checked-icon="triangle"
                                      :show-clear="false" :text-style="{fontSize: '10px', textAlign: 'left', paddingRight: '0px', paddingLeft: '0px',textIndent: '0px', color: '#B1B1B1', fontStyle: 'italic'}" :need-search="false" strategy="fixed">
                              <SpSelectOption v-for="(ac, index) in currency" :key="index" class="font-10-option" font-size="10px" :label="ac" :value="ac" />
                            </SpSelect>
                            <SpInput v-model="cargoOrders.hireRateDiotCustom" :height="14" :width="40" type="bottomBorder3"
                                     :precision="2" class=""
                                     :text-style="{fontSize: '10px', textAlign: 'center', paddingRight: '0px', paddingLeft: '0px', color: '#B1B1B1', fontStyle: 'italic', textIndent: 0 }"
                                     text-type="number" :min="0.5" :max="99999.99" />
                            <span style="line-height: 16px">DIOT(Daily Include Overtime)</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-show="hireRateDiotType === 'pdDio'" class="flex-al-center flex-jc-start" style="">
                    <div class="" style="width: auto">
                      <div class="flex-al-center flex-jc-start">
                        <div style="">
                          <div class="flex-jc-start">
                            <div class="flex-jc-start">
                              <SpSelect v-model="cargoOrders.hireRateCc" checked-icon="triangle" :height="14" class="font-10-select" :width="36"
                                        type="bottomBorder1"
                                        :show-clear="false" :text-style="{fontSize: '10px', textAlign: 'left', paddingRight: '0px',paddingLeft: '0px', textIndent: '0px', color: '#B1B1B1', fontStyle: 'italic'}" :need-search="false" strategy="fixed">
                                <SpSelectOption v-for="(ac, index) in currency" :key="index" class="font-10-option" font-size="10px" :label="ac" :value="ac" />
                              </SpSelect>
                              <SpInput v-model="cargoOrders.hireRateSplitCustom" :height="14" :width="40" type="bottomBorder3"
                                       :precision="2" class=""
                                       :text-style="{fontSize: '10px', textAlign: 'center', paddingRight: '0px', paddingLeft: '0px', color: '#B1B1B1', fontStyle: 'italic', textIndent: 0 }"
                                       text-type="number" :min="0.5" :max="99999.99" />
                              <span style="line-height: 16px">PD for the 1st</span>
                              <SpInput v-model="cargoOrders.hireRateSplitTime" :height="14" :width="36" type="bottomBorder3"
                                       :precision="2" class=""
                                       :text-style="{fontSize: '10px', textAlign: 'center', paddingRight: '0px', paddingLeft: '0px', color: '#B1B1B1', fontStyle: 'italic', textIndent: 0 }"
                                       text-type="number" :min="0.5" :max="99999.99" />
                              <span style="line-height: 16px">Days</span>
                            </div>
                            <div class="flex-jc-start" style="margin-top: 2px">
                              <span style="line-height: 16px; padding-right: 3px;">Thereafter</span>
                              <SpSelect v-model="cargoOrders.hireRateCc" :height="14" class="font-10-select" :width="36"
                                        type="bottomBorder1" checked-icon="triangle"
                                        :show-clear="false" :text-style="{fontSize: '10px', textAlign: 'center', paddingRight: '0px', paddingLeft: '0px', textIndent: '0px', color: '#B1B1B1', fontStyle: 'italic'}" :need-search="false" strategy="fixed">
                                <SpSelectOption v-for="(ac, index) in currency" :key="index" class="font-10-option" font-size="10px" :label="ac" :value="ac" />
                              </SpSelect>
                              <SpInput v-model="cargoOrders.hireRateDiotCustom" :height="14" :width="40" type="bottomBorder3"
                                       :precision="2" class=""
                                       :text-style="{fontSize: '10px', textAlign: 'center', paddingRight: '0px', paddingLeft: '0px', color: '#B1B1B1', fontStyle: 'italic' }"
                                       text-type="number" :min="0.5" :max="99999.99" />
                              <span style="line-height: 16px">DIOT</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="flex-jc-start">
                    <span style="line-height: 16px; margin-right: 3px;margin-left: 2px">Plus BB:</span>
                    <SpSelect v-model="cargoOrders.hireRateCc" :height="14" class="font-10-select" :width="36"
                              type="bottomBorder1" checked-icon="triangle"
                              :show-clear="false" :text-style="{fontSize: '10px', textAlign: 'left', paddingRight: '0px',paddingLeft: '0px', textIndent: '0px', color: '#B1B1B1', fontStyle: 'italic'}" :need-search="false" strategy="fixed">
                      <SpSelectOption v-for="(ac, index) in currency" :key="index" class="font-10-option" font-size="10px" :label="ac" :value="ac" />
                    </SpSelect>
                    <SpInput v-model="cargoOrders.plusBbLumpsumCustom" :height="14" :width="40" type="bottomBorder3"
                             :text-style="{fontSize: '10px', textAlign: 'center', paddingRight: '2px', color: '#B1B1B1', fontStyle: 'italic',textIndent: '0px' }"
                             :precision="0" text-type="number" :min="0" :max="999999999" />
                    <span style="line-height: 16px">In Lumpsum</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="geli-bar" />
        <div class="flex-al-center flex-jc-start mg-b-8" style="height: 40px">
          <div class="text-right" style="width: 82px; padding-right: 6px">
            <span class="sp-color-18">Address Comm:</span>
          </div>
          <div class="flex-1">
            <SpSelect
              v-model="cargoOrders.adcom" :height="16" class="font-10-select" :width="50"
              type="bottomBorder2" select-icon-color="#EEB336" checked-icon="triangle"
              :show-clear="false" :text-style="{fontSize: '10px', textAlign: 'left', paddingRight: '0px', textIndent: '0px'}" :need-search="false" strategy="fixed">
              <SpSelectOption v-for="(ac, index) in addressCommissionOptions" :key="index" class="font-10-option" font-size="10px" :label="ac.label" :value="ac.value" />
            </SpSelect>
          </div>
        </div>
      </div>
    </div>
    <div style="width: 455px;padding-top: 12px">
      <el-table class="cus-el-table-no-pd" :header-cell-style="{background:'#D6E9F0', textAlign: 'center'}" border

                :data="new Array(1).fill({quantity: null})" row-key="id">
        <el-table-column prop="name" width="171">
          <template #header="scope">
            <div class="table-header">
              Cargo Quantity
              <div>（{{ quantityUnit }}）</div>
            </div>
          </template>
          <template #default="scope">
            <p class="font10 sp-color-18 text-center">COA total or Per shipment</p>
            <div class="flex-al-center flex-jc-bt">
              <div class="flex-1">
                <SpInput v-model="cargoOrders.quantityMin"
                         :text-style="{fontSize: '12px', textAlign: 'center', textIndent: 0, paddingLeft: '0px'}"
                         :precision="0" text-type="number" :min="1" :max="999999"
                         height="30"
                         class="quantity-input" type="warn3" />
              </div>

              -
              <div class="flex-1">
                <SpInput v-model="cargoOrders.quantityMax"
                         :text-style="{fontSize: '12px', textAlign: 'center', textIndent: 0, paddingLeft: '0px'}"
                         :precision="0" text-type="number" :min="1" :max="999999"
                         height="30"
                         class="quantity-input" type="warn3" />
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="name">
          <template #header="scope">
            <div class="table-header">
              CAPA  Required
              <div>（CBM）</div>
            </div>
          </template>
          <template #default="scope">
            <p class="font10 sp-color-18 text-center"> Cargo Quantity x SF</p>
            <div class="flex-al-center flex-jc-bt">
              <div class="flex-1">
                <SpInput v-model="cargoOrders.capacityMin"
                         :text-style="{fontSize: '12px', textAlign: 'center', textIndent: 0, paddingLeft: '0px'}"
                         :precision="0" text-type="number" :min="1" :max="999999"
                         height="30"
                         class="quantity-input" type="warn3" />
              </div>
              -
              <div class="flex-1">
                <SpInput v-model="cargoOrders.capacityMax"
                         :text-style="{fontSize: '12px', textAlign: 'center', textIndent: 0, paddingLeft: '0px'}"
                         :precision="0" text-type="number" :min="1" :max="999999"
                         height="30"
                         class="quantity-input" type="warn3" />
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="name" width="142">
          <template #header="scope">
            <div class="table-header">
              Actual Weight
              <div>（MT）</div>
            </div>
          </template>
          <template #default="scope">
            <p class="font10 sp-color-18 text-center"> Cargo Quantity x WF</p>
            <div class="flex-al-center flex-jc-bt">
              <div class="flex-1">
                <SpInput v-model="cargoOrders.weightMin"
                         :text-style="{fontSize: '12px', textAlign: 'center', textIndent: 0, paddingLeft: '0px'}"
                         :precision="0" text-type="number" :min="1" :max="999999"
                         height="30"
                         class="quantity-input" type="warn3" />
              </div>
              -
              <div class="flex-1">
                <SpInput v-model="cargoOrders.weightMax"
                         :text-style="{fontSize: '12px', textAlign: 'center', textIndent: 0, paddingLeft: '0px'}"
                         :precision="0" text-type="number" :min="1" :max="999999"
                         height="30"
                         class="quantity-input" type="warn3" />
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div style="margin-top: 17px">
        <span class="italic mg-b-8">VIA:</span>
        <div class="flex-jc-bt port-panel">
          <div class="left">
            <span style="position:relative; top: 2px;" class="italic">1st L/Port</span>
            <SpSelect v-model="cargoOrders.viaPortLoad.ports"
                      :port-but-single="true" strategy="fixed" :multi-but-one-close="true"
                      class="font-10-select singe-port-select" :width="86"
                      :text-style="{fontSize: '10px', textAlign: 'left', textIndent: 0, paddingLeft: '4px'}"
                      :options="portOptions"
                      multi-select
                      :placeholder="$l('Port Intention')"
                      type="warn3"
                      height="38" :back-option="true" :back-selected-option="true" business-type="port"
                      @change="(value,labels) => cargoOrders.viaPortLoadLabels= labels"
                      @search="(key)=>searchPort('ports',key)" />
            <div class="text-center" style="line-height: 8px">or</div>
            <SpSelect v-model="cargoOrders.viaPortLoad.alternates" strategy="fixed" :multi-but-one-close="true"
                      class="font-10-select" :width="86" :text-style="{fontSize: '10px', textAlign: 'left', textIndent: 0, paddingLeft: '4px'}"
                      :options="portOptions"
                      :placeholder="$l('Port Alternate')"
                      type="warn3"
                      height="38" multi-select :back-option="true" :back-selected-option="true" business-type="port"
                      @search="(key)=>searchPort('ports',key)" />
          </div>
          <div class="center flex-1">
            <div class="flex-1" style="margin-top: 0px">
              <p v-required class="italic" style="position: relative; top: 2px">Trade Area</p>
              <SpSelect v-model="cargoOrders.tradeArea.ports"
                        width="1" style="margin-bottom: 8px"
                        strategy="fixed" disabled
                        business-type="port" :port-but-single="true"
                        multi-select :text-style="{fontSize: '12px', textAlign: 'left', textIndent: 0, paddingLeft: '12px'}"
                        :multi-but-one-close="true"
                        :custom-selection-disable="true" :custom-selection-disable-length="2"
                        type="gray" height="38" class="font-12-select"
                        :placeholder="$l('Port')"
                        :back-option="true" :back-selected-option="true"
                        :options="portOptions"
                        @search="(key)=>searchPort('ports',key)" />
              <SpSelect v-model="cargoOrders.tradeArea.regions"
                        class="font-12-select mg-b-8"
                        business-type="port" strategy="fixed"
                        multi-select :text-style="{fontSize: '12px', textAlign: 'left', textIndent: 0, paddingLeft: '12px'}"
                        :multi-but-one-close="true"
                        type="warn" :options="countryOptions" height="38"
                        :placeholder="$l('Country or SAR')"
                        :back-option="true" :back-selected-option="true"
                        @change="(value,labels) => cargoOrders.tradeRegionLabels= labels"
                        @search="(key)=>searchPort('regions',key)" />
              <SpSelect v-model="cargoOrders.tradeArea.zones"
                        class="font-12-select mg-b-8"
                        business-type="port" strategy="fixed"
                        multi-select :text-style="{fontSize: '12px', textAlign: 'left', textIndent: 0, paddingLeft: '12px'}"
                        :multi-but-one-close="true"
                        type="warn" :options="zoneOptions" height="48"
                        :placeholder="$l('Sea Area')"
                        :back-option="true" :back-selected-option="true"
                        @change="(value,labels) => cargoOrders.tradeZoneLabels= labels"
                        @search="(key)=>searchPort('zones',key)" />
            </div>
          </div>
          <div class="right" style="padding-top: 46px">
            <span style="position:relative; top: 2px;" class="italic">Last D/Port</span>

            <SpSelect v-model="cargoOrders.viaPortDischarge.ports"
                      :port-but-single="true" strategy="fixed"
                      class="font-10-select singe-port-select" :width="86" :text-style="{fontSize: '10px', textAlign: 'left', textIndent: 0, paddingLeft: '4px'}"
                      :options="portOptions"
                      :placeholder="$l('Port Intention')"
                      type="warn3" :multi-but-one-close="true"
                      @change="(value,labels) => cargoOrders.viaPortDischargeLabels= labels"
                      height="36" :back-option="true" :back-selected-option="true" business-type="port"
                      @search="(key)=>searchPort('ports',key)" />
            <div class="text-center" style="line-height: 8px">or</div>
            <SpSelect v-model="cargoOrders.viaPortDischarge.alternates" strategy="fixed"
                      class="font-10-select" :width="86" :text-style="{fontSize: '10px', textAlign: 'left', textIndent: 0, paddingLeft: '4px'}"
                      :options="portOptions"
                      :placeholder="$l('Port Alternate')"
                      type="warn3" :multi-but-one-close="true"
                      height="50" multi-select :back-option="true" :back-selected-option="true" business-type="port"
                      @search="(key)=>searchPort('ports',key)" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { computed, onMounted, reactive, ref, watch } from 'vue'
import SpSelect from '@/components/common/SpSelect.vue'
import SpSelectOption from '@/components/common/SpSelectOption.vue'
import { SAFE_PORTS, ADDRESS_COMMISSION_OPTIONS, CURRENCY } from '@/config/port'
import SpInput from '../../../common/SpInput'
import _uniq from 'lodash/uniq'
import _uniqBy from 'lodash/uniqBy'
import { getCountrySpareList } from '../../../../request/APIs/common'
import { addressMarineSearch } from '../../../../request/APIs/co'
import SpButton from '../../../common/SpButton'
import DwtSelect from './DwtSelect'
import DurationSelect from './DurationSelect'
import HireRate from './HireRate'

export default {
  name: 'OrderInfo',
  components: { HireRate, DurationSelect, DwtSelect, SpButton, SpInput, SpSelect, SpSelectOption },
  props: {
    modelValue: {
      type: Object,
      default: () => {
      }
    },

    cargoIndex: {
      type: Number,
      default: null
    },

    isCorrect: {
      type: String,
      default: ''
    },

    quantityUnit: {
      type: String,
      default: 'CBM'
    },

    defaultOptions: {
      type: Object,
      default: () => {
      }
    },

    defaultTypes: {
      type: Object,
      default: () => {
      }
    }
  },

  emits: ['update:modelValue'],
  setup (props, ctx) {
    const currency = ref(CURRENCY)
    const addressCommissionOptions = ref(ADDRESS_COMMISSION_OPTIONS)
    const safePorts = ref(SAFE_PORTS)
    const cargoOrders = computed({
      get () {
        return props.modelValue
      },
      set (nv) {
        ctx.emit('update:modelValue', nv)
      }
    })

    const portOptions = ref([])
    const countryOptions = ref([])
    const zoneOptions = ref([])

    const searchPort = (type, keyword) => {
      addressMarineSearch({ type, keyword, page: 1 }).then(res => {
        if (res.code === 1) {
          const options = (res.data.data || res.data).map(item => ({
            value: item.id,
            label: item.name
          }))
          if (type === 'ports') {
            const ops = (res.data.data || res.data).map(item => ({
              value: item.id,
              label: item.name,
              countryId: item.countryId
            }))
            portOptions.value = _uniqBy([...portOptions.value, ...ops], 'value')
          }
          if (type === 'regions') {
            countryOptions.value = _uniqBy([...countryOptions.value, ...options], 'value')
          }
          if (type === 'zones') {
            zoneOptions.value = _uniqBy([...zoneOptions.value, ...options], 'value')
          }
        }
      })
    }
    // 编辑 货盘 初始化port
    const allCountrys = ref([])
    onMounted(() => {
      // 获取港口及泊位数
      if (localStorage.getItem('countrysRegion')) {
        const countrysRegion = JSON.parse(localStorage.getItem('countrysRegion'))
        const options = countrysRegion.map(item => ({
          value: item.id,
          label: item.name
        }))
        countryOptions.value = _uniqBy([...countryOptions.value, ...options], 'value')
      } else {
        addressMarineSearch({ type: 'regions', page: 1 }).then((res) => {
          const options = (res.data.data || res.data).map(item => ({
            value: item.id,
            label: item.name
          }))
          countryOptions.value = _uniqBy([...countryOptions.value, ...options], 'value')
          localStorage.setItem('countrysRegion', JSON.stringify(res.data))
        })
      }

      // 获取所有国家

      if (localStorage.getItem('countrysSpare')) {
        const countrys = JSON.parse(localStorage.getItem('countrysSpare'))
        const options = countrys.map(item => ({
          value: item.id,
          label: item.name
        }))
        allCountrys.value = _uniqBy([...options], 'value')
      } else {
        getCountrySpareList().then((res) => {
          const options = (res.data.data || res.data).map(item => ({
            value: item.id,
            label: item.name
          }))
          allCountrys.value = _uniqBy([...options], 'value')
          localStorage.setItem('countrysSpare', JSON.stringify(res.data))
        })
      }

      const allZones = ref([])
      if (localStorage.getItem('zonesList')) {
        const zones = JSON.parse(localStorage.getItem('zonesList'))
        const options = zones.map(item => ({
          value: item.id,
          label: item.name
        }))
        zoneOptions.value = _uniqBy([...options], 'value')
      } else {
        addressMarineSearch({ type: 'zones', keyword: 'world wide', page: 1 }).then(res => {
          if (res.code === 1) {
            const options = (res.data.data || res.data).map(item => ({
              value: item.id,
              label: item.name
            }))
            zoneOptions.value = _uniqBy([...zoneOptions.value, ...options], 'value')
          }
        })
      }
    })

    watch(props.defaultOptions, () => {
      portOptions.value = props.defaultOptions?.ports
      countryOptions.value = props.defaultOptions?.regions
      zoneOptions.value = props.defaultOptions?.zones
    })

    const delyPortsSelected = reactive({
      port: null,
      region: null,
      zone: null
    })
    const delyPortsSelectedOption = {
      port: null,
      region: null,
      zone: null
    }
    const redelPortsSelectedOption = {
      port: null,
      region: null,
      zone: null
    }
    const redelPortsSelected = reactive({
      port: null,
      region: null,
      zone: null
    })
    const lpsChangeNum = ref(0) // 初始进入 变化不改变
    const portChange = (type, value, labels, optionSeleted) => {
      let portSelectedLabels = ''
      let portsCountryIds = []
      const portsCountry = []
      if (optionSeleted) {
        portsCountryIds = Object.values(optionSeleted).map(item => parseInt(item.countryId))
        portsCountryIds = _uniq(portsCountryIds)
      }
      portsCountryIds.forEach(ci => {
        const country = allCountrys.value.find(co => parseInt(co.value) === parseInt(ci))
        portsCountry.push(country?.label || '')
        portSelectedLabels = portsCountry.join(',')
      })
      if (type === 'delyPort') {
        delyPortsSelected.port = portSelectedLabels
        delyPortsSelectedOption.port = optionSeleted
      } else {
        redelPortsSelected.port = portSelectedLabels
        redelPortsSelectedOption.port = optionSeleted
      }
      props.modelValue.delyPortsSelectedOption = delyPortsSelectedOption
      props.modelValue.redelPortsSelectedOption = redelPortsSelectedOption
    }

    const setdelyPortsSelected = (type, labels, optionSeleted) => {
      if (type === 'delyPortRegionLabels') {
        delyPortsSelected.region = labels
        props.modelValue.delyPortsSelectedOption.region = optionSeleted
      }
      if (type === 'delyPortZoneLabels') {
        delyPortsSelected.zone = labels
        props.modelValue.delyPortsSelectedOption.zone = optionSeleted
      }

      props.modelValue.delyPortsSelectedOption = delyPortsSelectedOption
    }
    const setredelPortsSelected = (type, labels, optionSeleted) => {
      if (type === 'redelPortRegionLabels') {
        redelPortsSelected.region = labels
        redelPortsSelectedOption.region = optionSeleted
      }
      if (type === 'redelPortZoneLabels') {
        redelPortsSelected.zone = labels
        redelPortsSelectedOption.zone = optionSeleted
      }

      props.modelValue.redelPortsSelectedOption = redelPortsSelectedOption
    }
    const HireRateRef = ref(null)

    const hireRateDiotType = computed(() => {
      return HireRateRef?.value?.hireRateDiotType
    })
    return {
      portOptions,
      countryOptions,
      zoneOptions,
      searchPort,
      cargoOrders,
      safePorts,
      delyPortsSelected,
      redelPortsSelected,
      portChange,
      setdelyPortsSelected,
      setredelPortsSelected,
      HireRateRef,
      hireRateDiotType,
      currency,
      addressCommissionOptions
    }
  }
}
</script>

<style scoped lang="less">
.labels-panel {
  background: #FEF4DD;
  height: 50px;
  box-sizing: border-box;
  padding: 8px 8px;
  font-size: 12px;
  position: relative;
  top: -5px;
  text-align: left;
}
.zhijian{
  display: inline-block;
  width: 5px;
  border-top: 1px solid #000000;
  height: 3px;
  margin-left: 6px;
  margin-right: 4px;
}
p {
  margin: 0;
}
.zone-title{
  margin-top: 21px; margin-bottom: 0; position: relative; z-index: 1
}
.zone-select{
  position:relative; top: -4px; margin: 0
}
.ps-content {
  color: #B1B1B1;
  padding: 0 4px 4px 3px;
  .title {
    color: #3A909D;
    opacity: 0.5;
  }
  border: 1px dashed #bdd9dd;
  border-radius: 5px;
}
.tct-order-panel {
  .port-panel {
    .center {
      padding: 0 7px;
    }
  }
  .table-header{
    padding: 12px 0;
    line-height: 12px;
    font-size: 12px;
    div{
      font-size: 10px;
      margin-top: 2px;
    }
  }
  .mg-b-8{
    margin-bottom: 8px;
  }
  .pd-t-8{
    padding-top: 8px;
  }
  .item {
    .title {
      margin-top: 28px;
      margin-bottom: 4px;
    }
  }
  .quantity-input{
    position:relative; top: -2px; margin: 0
  }
  .geli-bar{
    height: 6px;
    background: #FFFFFF;
  }
}
</style>

<style lang="less">
.cus-el-table-no-pd .el-table__cell {
  .cell {
    padding: 0 4px 2px 4px !important;
  }
  padding: 0 !important;
}
</style>
